import script from "./UiTab.vue?vue&type=script&setup=true&lang=js"
export * from "./UiTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__